module.exports = __webpack_public_path__ + "img/quest_icon_0052_map.5a6b9ce0.png";